<template>
  <div>
    <a-modal
      :centered = "true"
      :visible="visible"
      :closable = "false"
      :keyboard="false"
      :maskClosable="false"
      width="900px"
      :mask="true"
      :destroyOnClose="true"
      @cancel="visible = false"
    >
      <div>
        <!-- 超期应收 -->
        <div class="title_tip">
          <div class="tip_icon">
            <pt-icon type="icon-GroupCopy2" style="font-size: 30px"></pt-icon>
          </div>
          <div class="">
            <div class="tip_content">{{ $t('key14chaoqiyingshou') }}</div>
          </div>
        </div>
        <!-- 已超过的超期 -->
        <div class="content" v-if="tableData.length > 0">
          <!-- 以下项目的预计收款日期已经过期，请修改！ -->
          <div class="sub_title" style="display: flex; align-items: center;">
            <span style="color: red;font-size: 30px;margin-top: 10px;">*</span>
            <span style="margin-left: 5px;">{{ $t('key14chaoqiyingshoutishi') }}</span>
          </div>
          <div class="table_div">
            <a-spin :spinning="loading">
              <el-table
                class="dealBeOver_table"
                :data="tableData"
                style="color: #EE4248 ;"
              >
                <el-table-column
                  prop="projectName"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('keyxiangmumingcheng')"
                >
                </el-table-column>
                <el-table-column
                  prop="payerName"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('key14fukuanfang')"
                >
                </el-table-column>
                <el-table-column
                  prop="totalComminssion"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('key14yongjinshue')"
                >
                  <template slot-scope="scope">
                    ¥{{scope.row.totalComminssion}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="changeOutTime"
                  align="left"
                  min-width="115"
                  show-overflow-tooltip
                  :label="$t('keychargeoutshijian')">

                </el-table-column>
                <el-table-column
                  prop="expectPayeeTime"
                  align="left"
                  min-width="100"
                  :label="$t('keyyujishoukuanriqi')">
                  <template slot-scope="scope">
                    <span>{{scope.row.expectPayeeTime}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="changePayTimeCount"
                  align="left"
                  min-width="100"
                  :label="$t('keyyixiugaicishu')">
                  <template slot-scope="scope">
                    <span>{{scope.row.changePayTimeCount}}{{ $t('common.times') }}</span>
                  </template>
                </el-table-column>
                <!-- 强制修改 -->
                <el-table-column
                  prop="expectPayeeTime"
                  align="left"
                  width="150"
                  :label="$t('baseVO.operate')">
                  <template slot-scope="scope">
                    <a-button size="small" @click="updateRow(scope.row)" class="update_button"><pt-icon type="icon-bianji2"/>{{$t('baseVO.forceModify')}}</a-button>
                  </template>
                </el-table-column>
              </el-table>
            </a-spin>

          </div>
        </div>

        <!-- 七天内的 -->
        <div class="content" style="margin-top: 10px;" v-if="soonTableData.length > 0">
          <div class="sub_title" style="display: flex; align-items: center;">
            <span style="color: red;font-size: 30px;margin-top: 10px;">*</span>
            <span style="margin-left: 5px;">{{ $t('key14chaoqiyingshoutishiUpdate') }}</span>
          </div>
          <div class="table_div">
            <a-spin :spinning="loading">
              <el-table
                class="dealBeOver_table"
                :data="soonTableData"
              >
                <el-table-column
                  prop="projectName"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('keyxiangmumingcheng')"
                >
                </el-table-column>
                <el-table-column
                  prop="payerName"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('key14fukuanfang')"
                >
                </el-table-column>
                <el-table-column
                  prop="totalComminssion"
                  align="left"
                  min-width="100"
                  show-overflow-tooltip
                  :label="$t('key14yongjinshue')"
                >
                  <template slot-scope="scope">
                    ¥{{scope.row.totalComminssion}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="changeOutTime"
                  align="left"
                  min-width="115"
                  show-overflow-tooltip
                  :label="$t('keychargeoutshijian')">

                </el-table-column>
                <el-table-column
                  prop="expectPayeeTime"
                  align="left"
                  min-width="100"
                  :label="$t('keyyujishoukuanriqi')">
                  <template slot-scope="scope">
                    <span>{{scope.row.expectPayeeTime}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="changePayTimeCount"
                  align="left"
                  min-width="100"
                  :label="$t('keyyixiugaicishu')">
                  <template slot-scope="scope">
                    <span>{{scope.row.changePayTimeCount}}{{ $t('common.times') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="expectPayeeTime"
                  align="left"
                  width="150"
                  :label="$t('baseVO.operate')">
                  <template slot-scope="scope">
                    <a-button size="small" @click="updateRow(scope.row)" class="update_button"><pt-icon type="icon-bianji2"/>{{$t('baseVO.update')}}</a-button>
                  </template>
                </el-table-column>
              </el-table>
            </a-spin>

          </div>
        </div>
      </div>
      <div slot="footer">
        <a-button :loading="loading" key="submit"  type="primary"  style="margin-right: 10px" @click="visible = false" :disabled="tableData.length > 0">{{ $t('baseVO.close') }}</a-button>
      </div>
    </a-modal>


    <!-- 修改弹窗 -->
    <pt-modal :title="$t('keyxiugaichaoqiyingshou')" :visible='canedit' :loading="saveLoading"
              :width='800' @cancel='closeEdit' @ok='saveEdit'  >
      <div slot='content'>
        <div style="background: rgba(248,249,251,0.62);
            border-radius: 4px;padding: 20px 20px 20px 20px;">
          <a-form-model ref="saveModel" layout="vertical" :model="saveRow">

            <a-row :gutter="16">
              <a-col :span="7">
                <a-form-model-item :label="$t('keyxiangmumingcheng')">
                  <span class="update_value">{{ saveRow.projectName }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="7">
                <a-form-model-item :label="$t('key14fukuanfang')">
                  <span class="update_value">{{ saveRow.payerName }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="6">
                <a-form-model-item :label="$t('key14yongjinshue')">
                  <span class="update_value">¥ {{ saveRow.totalComminssion }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="4">
                <a-form-model-item :label="$t('keychargeoutshijian')">
                  <span class="update_value">{{ saveRow.changeOutTime }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="16">
              <a-col :span="7">
                <a-form-model-item :label="$t('keyyixiugaicishu')">
                  <span class="update_value">{{ saveRow.changePayTimeCount }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="7">
                <a-form-model-item :label="$t('keyyuanyujishoukuanshijian')">
                  <span class="update_value">{{ saveRow.oldExpectPayeeTime }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="10">
                <a-form-model-item
                  prop="expectPayeeTime"
                  :label="$t('keyxianyujishoukuanshijian')"
                  :rules="[
                      { required: true, message: $t('keyxianyujishoukuanshijianqingshuru'), trigger: 'change' }
                    ]"
                  class="required"
                >
                  <a-date-picker
                    value-format="YYYY-MM-DD"
                    :disabled-date="disabledMonthDate"
                    v-model="saveRow.expectPayeeTime"
                    style="width: 90%"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  prop="remarks"
                  :label="$t('keyxiugaiyuanyin')"
                  :rules="[
                      { required: true, message: $t('keyxiugaiyuanyinqingshuru'), trigger: 'change' }
                    ]"
                  class="required"
                >
                  <a-textarea
                    v-model="saveRow.remarks"
                    :rows="5"
                    :maxlength="200"
                    :placeholder="$t('keyyujishoukuanriqiqingshurushuoming2')"
                    style="width: 100%"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

          </a-form-model>
        </div>

      </div>
    </pt-modal>

  </div>
</template>

<script>
import DealConfrimApi from '@/api/mine/dealConfirm'
import moment from "moment";
import financialAPI from "@/api/database/financial";
export default {
  name: 'DealBeOverDue',
  data() {
    return {
      loading:false,
      visible:false,
      saveLoading:false,
      canedit:false,
      tableData:[],
      soonTableData:[],
      currentCreateTime:'',
      saveRow:{
        dealConfirmId:'',
        expectPayeeTime:'',
        remarks:'',
      }
    }
  },
  computed: {
    days(){
      if(this.saveRow.expectPayeeTime && this.currentCreateTime){
        return this.$moment(this.saveRow.expectPayeeTime).diff(this.currentCreateTime,'days')
      }else{
        return 0
      }
    },
  },
  mounted() {
    this.selectDeal();
  },
  methods: {
    saveChangeSubmit(){
      //校验修改的日期是否正确
      this.checkDate();
    },
    checkDate: function() {
      let type = false
      for(var i = 0;i < this.tableData.length;i++){
        //上个月最后一天时间
        let lastMonthEndDay = this.$moment()
        //当前charge out时间
        let projectEndtime = this.$moment( this.tableData[i].expectPayeeTime);
        if(projectEndtime <= lastMonthEndDay){
          type = false;
          break;
        }else{
          type = true;
        }
      }
      if(!type){
        this.$message.error("预计收款日期必须大于当前日期，不能保存！")
        return false;
      }
      this.submit()
    },
    updateRow(row){
      this.canedit = true
      this.currentCreateTime = row.createTime
      this.saveRow.dealConfirmId = row.id
      this.saveRow.projectName = row.projectName
      this.saveRow.payerName = row.payerName
      this.saveRow.totalComminssion = row.totalComminssion
      this.saveRow.changeOutTime = row.changeOutTime
      this.saveRow.changePayTimeCount = row.changePayTimeCount
      this.saveRow.oldExpectPayeeTime = row.expectPayeeTime
      this.saveRow.expectPayeeTime = ""
      this.saveRow.remarks = ""
    },
    closeEdit() {
      this.canedit = false
    },
    saveEdit(){
      let _this = this;
      this.$refs.saveModel.validate().then(valid => {
        this.saveLoading = true
        financialAPI.deskTopupdateReceivable(_this.saveRow).then(res => {
          if (res.code == 1) {
            _this.saveLoading=false
            _this.$message.success("修改成功")
            _this.selectDeal()
            _this.closeEdit()
          } else {
            _this.saveLoading = false
          }
        }).catch(() => {
          _this.saveLoading = false
        })

      })
    },
    disabledMonthDate(current){
      //禁用当前月之前的日期
      return (current && current <= this.$moment() ) || current > this.$moment().add(60, 'days');
    },
    // 查询超期的
    selectDeal(){
      this.loading = true
      this.tableData  = []
      DealConfrimApi.selectBeOverdueAll().then(res=>{
        if(res.code == 1){
          if(res.data){
            this.tableData = res.data;
          }
        }
        this.selectDealSoon()
      }).finally(() => {
        this.loading = false
      })
    },
    // 查询七天内的
    selectDealSoon(){
      this.loading = true
      this.soonTableData = []
      DealConfrimApi.selectBeOverdueAllExpiringSoon().then(res=>{
        if(res.code == 1){
          if(res.data){
            if(res.data != null){
              this.soonTableData = res.data;
            }
          }
        }
        if(this.tableData.length > 0 || this.soonTableData.length > 0){
          this.visible = true;
        }else{
          this.visible = false;
        }
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style scoped lang="less">
.table_div /deep/ .el-table td, .el-table th.is-leaf{
  border-bottom: 0px solid #EBEEF5 !important;
}
.table_div /deep/ .el-table--fit{
  padding: 20px;
}
.table_div /deep/  .el-table, .el-table__expanded-cell {
  background-color: rgba(248,249,251,0.62);
}

.table_div /deep/ .el-table tr {
  background-color:  rgba(248,249,251,0.62)!important;
}
.table_div /deep/  .el-table--enable-row-transition .el-table__body td, .el-table .cell{
  background-color:  rgba(248,249,251,0.62);
}
.title_tip{
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .tip_icon{

  }
  .tip_content{
    margin-left: 10px;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
  }
}
.content{
  padding: 0px 10px;
  min-height: 400px;


  .sub_title{
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
  }
  .table_div{
    margin-top: 0px;
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    border-radius: 0px 0px 4px 4px;
  }
  .trackTypeText{
    width: 60px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.update_button{
  height: 30px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
}
.update_value{
  margin-left: 4px;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}
</style>